<streamSheetView *ngIf="sheet_ready" [process]="process" [processes]="flowSheet.processes"
                 [streams]="flowSheet.streams"></streamSheetView>
